
/**
 * Functions for generating milestone content
 */

function describeMilestone(babyName: string, milestone: string): string {
  const descriptions: Record<string, string[]> = {
    'First smile': [
      `${babyName} gave us their very first real smile today! Not just a reflex, but a genuine, heart-melting expression of joy.`,
      `Today marked a precious moment - ${babyName}'s first true smile, lighting up their entire face and our hearts along with it.`,
      `The most magical thing happened today - ${babyName} smiled at me with intention, a small gesture that felt monumental.`,
      `${babyName}'s first real smile appeared today, transforming their whole face and making time stand still for a moment.`,
      `I was rewarded with ${babyName}'s first genuine smile today - a fleeting but perfect moment I'll never forget.`
    ],
    'Rolled over': [
      `${babyName} rolled over for the first time today! The look of surprise on their face was absolutely priceless.`,
      `A big achievement today as ${babyName} managed to roll over all by themselves, displaying their growing strength and coordination.`,
      `I watched in amazement as ${babyName} used their whole body to successfully roll over for the first time!`,
      `${babyName} seemed just as surprised as I was when they completed their first roll today, looking around with wide eyes.`,
      `After days of trying, ${babyName} finally managed to roll from back to tummy today, looking so proud of this accomplishment.`
    ],
    'First word': [
      `${babyName} said their first distinguishable word today! We've been waiting for this moment and it was worth every second.`,
      `The sweetest sound today as ${babyName} uttered their first clear word, a magical milestone in their development.`,
      `I could hardly believe my ears when ${babyName} spoke their first recognizable word today, looking right at me.`,
      `After weeks of babbling, ${babyName} surprised us with their first real word today, said with such clear intention.`,
      `A breakthrough moment as ${babyName}'s babbles transformed into their very first word, marking the beginning of language.`
    ],
    'First steps': [
      `${babyName} took their very first steps today, wobbling bravely between my outstretched arms with determination written all over their face.`,
      `An unforgettable moment today as ${babyName} stood up and took their first independent steps, beginning a new chapter of exploration.`,
      `We witnessed history today - ${babyName}'s first tentative steps, a small triumph of balance and courage.`,
      `The concentration on ${babyName}'s face as they took their first unsteady steps today was absolutely priceless.`,
      `My heart swelled with pride watching ${babyName} take those first wobbly steps today, eager to explore their expanding world.`
    ],
    'First tooth': [
      `${babyName}'s first tooth has finally made an appearance! After days of extra cuddles and soothing, the tiny white edge is now visible.`,
      `Today we discovered ${babyName}'s first tooth has emerged, a tiny pearl peeking through their bottom gum.`,
      `After weeks of drooly grins, ${babyName}'s first tooth has finally broken through, marking a new phase in their development.`,
      `I spotted ${babyName}'s first tooth today - a tiny white edge just visible on their bottom gum after days of fussiness.`,
      `The mystery of ${babyName}'s recent discomfort was solved today when we spotted their very first tooth emerging.`
    ],
    'First laugh': [
      `${babyName} let out their first real laugh today, a sound so pure and joyful it brought tears to my eyes.`,
      `The most magical sound filled our home today - ${babyName}'s first genuine laugh, bubbling up unexpectedly.`,
      `${babyName} surprised us with their first full laugh today, triggered by the simplest game of peekaboo.`,
      `I'll never forget the sound of ${babyName}'s first real laugh today - more beautiful than any music.`,
      `${babyName} discovered laughter today, their first real giggle cascading into a full belly laugh that had us all joining in.`
    ],
    'Sitting up': [
      `${babyName} sat unassisted for the first time today, looking so proud of their new upright perspective on the world.`,
      `A big milestone today as ${babyName} managed to balance sitting up all by themselves for several minutes.`,
      `${babyName} has mastered sitting up independently today, opening up a whole new way to play and interact.`,
      `The determination on ${babyName}'s face as they worked to maintain balance while sitting was inspiring to watch.`,
      `${babyName} seemed so pleased with themselves today when they realized they could stay sitting up without support.`
    ]
  };
  
  const defaultDescriptions = [
    `${babyName} reached a wonderful milestone today: ${milestone}. It's amazing to witness these moments of growth.`,
    `Today, ${babyName} achieved something new: ${milestone}. Each of these steps forward fills me with wonder and pride.`,
    `I was moved to tears watching ${babyName} reach this important milestone today: ${milestone}.`,
    `${babyName}'s development took a significant leap today with ${milestone}, a precious moment I'll always remember.`,
    `Today marked an important achievement for ${babyName}: ${milestone}. These milestones arrive so quickly.`
  ];
  
  const options = descriptions[milestone] || defaultDescriptions;
  return options[Math.floor(Math.random() * options.length)];
}

export function generateMilestonesContent(babyName: string, milestones: string[]): string {
  if (milestones.length === 0) return '';
  
  const introductions = [
    `I'm so proud to record that`,
    `A special milestone today:`,
    `Worth celebrating today:`,
    `A moment to remember:`,
    `Something remarkable happened:`,
    `I need to document this special achievement:`,
    `An exciting development today:`
  ];
  
  const introduction = introductions[Math.floor(Math.random() * introductions.length)];
  
  if (milestones.length === 1) {
    return `\n\n${introduction} ${describeMilestone(babyName, milestones[0])}`;
  }
  
  const milestonesText = milestones.map(milestone => describeMilestone(babyName, milestone));
  return `\n\n${introduction} ${milestonesText.join(". Also, ")}`;
}
